import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherBySourceId } from "../api/publisherService";
import { useGetCurrentUser } from "../utils/useCurrentUser";
import { isPublisherRoleOnly as checkIsPublisherRoleOnly } from "../utils/permissionsUtils";
export var usePublisherDataValidity = function () {
    var _a, _b;
    var ky = useOkapiKy();
    var _c = useGetCurrentUser(), currentUser = _c.data, userLoading = _c.isLoading;
    var activeRoles = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeRoles;
    var sourceId = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.sourceId;
    var isPublisherOnly = checkIsPublisherRoleOnly(activeRoles);
    var _d = useQuery(["publisherValidity", sourceId], function () { return fetchPublisherBySourceId(ky, sourceId); }, {
        enabled: isPublisherOnly && !!sourceId,
        retry: false,
        staleTime: 0,
        cacheTime: 0,
        refetchOnMount: "always",
    }), publisher = _d.data, publisherLoading = _d.isLoading, error = _d.error;
    var needsDataConfirmation = (function () {
        if (!isPublisherOnly)
            return false;
        if (!publisher)
            return false;
        if (!publisher.dataConfirmationTime)
            return false;
        var confirmationDate = new Date(publisher.dataConfirmationTime);
        var oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return confirmationDate < oneYearAgo;
    })();
    var municipality = (_b = publisher === null || publisher === void 0 ? void 0 : publisher.mainAddress) === null || _b === void 0 ? void 0 : _b.municipality;
    return {
        needsDataConfirmation: needsDataConfirmation,
        isLoading: userLoading || (isPublisherOnly && sourceId && publisherLoading),
        isPublisherRoleOnly: isPublisherOnly,
        municipality: municipality,
        error: error,
    };
};
